import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Analytics } from '@vercel/analytics/react';
import 'react-toastify/dist/ReactToastify.css';

// Core Layout Components (Eager Loaded)
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Breadcrumbs from './components/Breadcrumbs';
import Loader from './components/Loader';
import Home from './pages/Home'; // Home is critical for LCP

// Lazy Loaded Pages
const Analysis = lazy(() => import('./pages/Analysis'));
const Report = lazy(() => import('./pages/Report'));
const About = lazy(() => import('./pages/About'));
const Compare = lazy(() => import('./pages/Compare'));
const Business = lazy(() => import('./pages/Business'));
const InteriorsRooms = lazy(() => import('./pages/InteriorsRooms'));
const InteriorsDecor = lazy(() => import('./pages/InteriorsDecor'));
const BlogHome = lazy(() => import('./pages/BlogHome'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Methodology = lazy(() => import('./pages/Methodology'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

function AppLayout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Hidden on home page for streamlined launch */}
        {!isHomePage && <TopBar />}
        <Navbar />
        
        <main style={{ flex: 1 }}>
          {!isHomePage && <Breadcrumbs />}
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/analysis" element={<Analysis />} />
              <Route path="/report/:analysisId" element={<Report />} />
              <Route path="/about" element={<About />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/business" element={<Business />} />
              <Route path="/interiors/analyze" element={<InteriorsRooms />} />
              <Route path="/interiors/decor" element={<InteriorsDecor />} />
              <Route path="/blog" element={<BlogHome />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        
        <Footer />
        
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Analytics />
      </div>
  );
}

export default App;
